var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Ocorrências" } },
          [
            _c("sc-reports-occurrences-dropdown", {
              model: {
                value: _vm.filters.occurrence,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "occurrence", $$v)
                },
                expression: "filters.occurrence"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          {
            attrs: {
              label: "Transportadora",
              type: !_vm.isValidLogisticProvider ? "is-danger" : "",
              message: !_vm.isValidLogisticProvider
                ? "Escolha uma transportadora"
                : ""
            }
          },
          [
            _c("sc-logistic-provider-dropdown", {
              attrs: { active: false },
              model: {
                value: _vm.filters.logistic_provider_id,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "logistic_provider_id", $$v)
                },
                expression: "filters.logistic_provider_id"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Métodos de entrega" } },
          [
            _c("sc-delivery-method-dropdown", {
              attrs: {
                "logistic-provider-id": _vm.filters.logistic_provider_id,
                "option-all": true,
                active: false
              },
              model: {
                value: _vm.filters.delivery_method_id,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "delivery_method_id", $$v)
                },
                expression: "filters.delivery_method_id"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Tipo de período" } },
          [
            _c(
              "sc-select",
              {
                attrs: { placeholder: "Selecione", expanded: "" },
                model: {
                  value: _vm.filters.date_type,
                  callback: function($$v) {
                    _vm.$set(_vm.filters, "date_type", $$v)
                  },
                  expression: "filters.date_type"
                }
              },
              _vm._l(_vm.periodsList, function(period) {
                return _c(
                  "option",
                  { key: period.value, domProps: { value: period.value } },
                  [_vm._v("\n          " + _vm._s(period.label) + "\n        ")]
                )
              })
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Período" } },
          [
            _c("sc-range-date-picker", {
              staticClass: "is-small",
              attrs: {
                "max-date": _vm.maxDate,
                format: _vm.formatDateRange,
                minDate: _vm.endLimit
              },
              model: {
                value: _vm.filters.dateRange,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "dateRange", $$v)
                },
                expression: "filters.dateRange"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-669d10ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-669d10ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider/components/sc-report-provider-filters/ScReportProviderFilters.vue
// module id = null
// module chunks = 